<script setup lang="ts">
import { Dayjs } from 'dayjs'
import { computed, watch } from 'vue'
import { useStore } from 'vuex'

import SancareGraphic from './SancareGraphic.vue'
import { ChartUnit } from './types'

export interface FinancialStatsProps {
  earlyLimit: Dayjs
  lateLimit: Dayjs
  chartUnit: ChartUnit
  labelSets: string[]
  selectedMedicalUnits: number[] | null
}

const store = useStore()
const props = withDefaults(
  defineProps<FinancialStatsProps>(),
  {
    chartUnit: ChartUnit.MONTH,
    labelSets: () => [],
    selectedMedicalUnits: () => [],
  }
)

const stats = computed(() => store.state.stats.financialStats)
watch([() => props.earlyLimit, () => props.lateLimit, () => props.chartUnit, () => props.selectedMedicalUnits], () => {
  refresh()
}, { immediate: true })

function refresh() {
  store.dispatch('getFinancialStats', {
    earlyLimit: props.earlyLimit.format('YYYY-MM-DD'),
    lateLimit: props.lateLimit.format('YYYY-MM-DD'),
    unit: props.chartUnit,
    medicalUnits: props.selectedMedicalUnits,
  })
}

</script>

<template>
  <div class="stat">
    <h1 class="stat-title">
      Analyse financière
    </h1>
    <div class="row">
      <h2 class="col-12 stat-graph-title">
        Gains et pertes - Revalorisation
      </h2>
    </div>
    <div class="stat-content row justify-content-around">
      <div class="col-12 row align-items-stretch g-0">
        <SancareGraphic
          :label-sets="labelSets"
          :serie="stats"
          :serie-infos="{
            positiveRevaluation: { label: 'Gain', unit: '€', color: '#31E1E3' },
            negativeRevaluation: { label: 'Perte', unit: '€', color: '#E331A9' },
          }"
          :label-y="'€'"
          type="bar"
          class="col-12"
        />
      </div>
    </div>
  </div>
</template>
